__turbopack_context__.v({
  "art": "_4_kxhq_art",
  "arts": "_4_kxhq_arts",
  "banner": "_4_kxhq_banner",
  "content": "_4_kxhq_content",
  "drift": "_4_kxhq_drift",
  "mask": "_4_kxhq_mask",
  "noArt": "_4_kxhq_noArt",
  "subtitle": "_4_kxhq_subtitle",
  "title": "_4_kxhq_title",
});
